import { useTranslation } from 'react-i18next'
import { formatCurrency, formatDate, formatDateTime } from '@/lib/utils'

/**
 * Locale-aware formatters bound to the active UI language, so components
 * don't each have to thread `i18n.language` through.
 */
export function useLocaleFormat() {
  const { i18n } = useTranslation()
  const locale = i18n.resolvedLanguage || 'en'

  return {
    formatCurrency: (amount: number) => formatCurrency(amount, locale),
    formatDate: (date: Date) => formatDate(date, locale),
    formatDateTime: (date: Date) => formatDateTime(date, locale),
  }
}
